import NavLeftStu from '../nav-main/src/v2/nav-left-stu';

/* istanbul ignore next */
NavLeftStu.install = function(Vue) {
  Vue.component(NavLeftStu.name, NavLeftStu);
};

export default NavLeftStu;
